module.exports = {
  title: "RBR760",
  axiosPrefix: "/dniapi",
  type: "orbi", // Available values: 'orbi', 'orbi'
  style: "gui-2-1", // Reserved. Available values: 'gui-2-1'
};
